const PREFIX = 'site/games/json-list/';
const API = 'https://storage.googleapis.com/storage/v1/b/robsonmedeiros/o';
const objectUrl = name => `${API}/${encodeURIComponent(name)}?alt=media`;
async function readJson(url, signal) {
  const response = await fetch(url, { cache: 'no-store', signal });
  if (!response.ok) {
    const error = new Error(`Falha no catálogo (${response.status})`);
    error.status = response.status;
    throw error;
  }
  return response.json();
}
export function normalizeUrl(value) {
  if (typeof value !== 'string') return '';
  const match = value.trim().match(/^\[[\s\S]*?\]\(([\s\S]*)\)$/);
  const url = (match ? match[1] : value.trim()).replace(/\\([()])/g, '$1');
  return /^https?:\/\//i.test(url) ? url : '';
}
export function normalizeGame(data, name) {
  if (!data || typeof data.title !== 'string' || !data.title.trim()) throw new Error(`Jogo inválido: ${name}`);
  const route = typeof data.playUrl === 'string' && data.playUrl.match(/^\/play\/([^/?#]+)\/?$/);
  const id = route ? decodeURIComponent(route[1]) : name.slice(PREFIX.length).replace(/\.json$/i, '');
  const game = { ...data, id, title: data.title.trim(), cover: normalizeUrl(data.cover), buildUrl: normalizeUrl(data.buildUrl), playUrl: `/play/${encodeURIComponent(id)}`, isLaunched: data.isLaunched === true || data.isLaunched === 'true' };
  for (const key of ['description', 'releaseDate', 'developer', 'publisher']) game[key] = typeof data[key] === 'string' ? data[key] : '';
  game.gallery = Array.isArray(data.gallery) ? data.gallery.map(normalizeUrl).filter(Boolean) : [];
  game.tags = Array.isArray(data.tags) ? data.tags.filter(tag => typeof tag === 'string') : [];
  return game;
}
export async function loadGames(signal) {
  let names = [];
  let pageToken;
  do {
    const query = new URLSearchParams({ prefix: PREFIX, delimiter: '/', fields: 'items(name),nextPageToken' });
    if (pageToken) query.set('pageToken', pageToken);
    const page = await readJson(`${API}?${query}`, signal);
    names.push(...(page.items || []).map(item => item.name));
    pageToken = page.nextPageToken;
  } while (pageToken);
  names = [...new Set(names)].filter(name => name.startsWith(PREFIX) && /\.json$/i.test(name) && name !== `${PREFIX}index.json`).sort();
  const results = await Promise.allSettled(names.map(async name => normalizeGame(await readJson(objectUrl(name), signal), name)));
  if (signal?.aborted) throw new DOMException('Aborted', 'AbortError');
  const games = results.filter(result => result.status === 'fulfilled').map(result => result.value);
  if (names.length && !games.length) throw new Error('Nenhum JSON pôde ser carregado');
  return { games, failedCount: results.length - games.length };
}
